module.exports = __webpack_public_path__ + "static/media/icon-popup-header.e1d32771.png";